<template>
  <FormStepInputs
    :step="{
      stepName: name,
      formInputs: content,
    }"
  >
    <template #ProductCard>
      <div data-test-id="product_list_component">
        <ProductCardList :fields="productCard" :portfolio="accountStore.identityDetails?.portfolio" />
      </div>
    </template>
  </FormStepInputs>

  <ModalDialog
    v-if="registerModal?.label"
    v-model="showRegisterPopup"
    :closeOnEsc="true"
    :showXCloseButton="true"
    size="md"
  >
    <div>
      <RichText :field="registerModal.label" />
      <button class="btn btn-primary btn-md w-full" @click="showRegisterPopup = false">{{ OK }}</button>
    </div>
  </ModalDialog>
</template>
<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import { getFormInput } from '@/utils/form-input-helper';
import ProductCardList from '@/components/ProductCardList/ProductCardList.vue';
import { useAccountStore } from '@/store';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import ModalDialog from '@/components/ModalDialog/ModalDialog.vue';
import { OK } from '@/constants/general-words.const';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';

const props = defineProps<{
  content: ISitecoreFormGenericInput[];
  id: string;
  name: string;
}>();
const accountStore = useAccountStore();
const productCard = ref(getFormInput(props.content, 'ProductCard'));
const registerModal = getFormInput(props.content, 'RegisterModal');
const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;
const route = useRoute();
const showRegisterPopup = ref(false);

onMounted(async () => {
  if (route?.query?.pop == 'reg') {
    showRegisterPopup.value = true;
    window.history.replaceState(null, '', window.location.pathname); // remove query to avoid showup again on refresh
  }

  pushAnalytics();

  const portfolio = accountStore.identityDetails?.portfolio;
  const anyInsurance = !!portfolio?.insurancePolicies?.length;
  const anyAssistance = !!portfolio?.assistanceProducts?.length;
  const anyBank = !!portfolio?.bankingProducts?.length;

  // ONLY show cross sell if there is no product
  if ((anyInsurance || anyAssistance || anyBank) && productCard.value.fields) {
    productCard.value && (productCard.value.crossSellPromo = []);
    productCard.value?.fields && (productCard.value.fields.crossSellPromo = []);
  }
});

const pushAnalytics = async () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};
</script>
